module.exports = __webpack_public_path__ + "static/media/metro3-5.98a23c9f.jpg";